var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.css(),attrs:{"href":"#","data-test":"atom-close-button"},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_c('AtomIcon',{attrs:{"name":"cross-modal","size":32}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }